import script from "./admin-main.vue?vue&type=script&setup=true&lang=ts"
export * from "./admin-main.vue?vue&type=script&setup=true&lang=ts"

import "./admin-main.vue?vue&type=style&index=0&id=0269b9a9&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0269b9a9"]])

export default __exports__